module.exports = __webpack_public_path__ + "assets/img/world_cup_ticket.jpg?7c90cea1f2bc0127ecc4daaf96843dc9";